import React from 'react';
import { Link } from 'react-router-dom';
import { MdOutlineFacebook } from "react-icons/md";
import { RiInstagramFill } from "react-icons/ri";
import '../sass/layout/_footer.scss';
import '../sass/base/_footer_typo.scss';

const Footer = () => {

    return (
        <footer className='footer'>
            <p className='first_p'>oliv' auto clean</p>
            <nav className="reseaux">
                <ul className='res-element'>
                    <li>
                        <Link
                            to='https://www.facebook.com/people/OlivAuto-Clean/100022508387801/'
                            target='_blank'
                            rel='noreferrer'
                            title='facebook'
                        >
                            <MdOutlineFacebook />
                        </Link>
                    </li>
                    <li>
                        <Link
                            to='https://www.instagram.com/olivautoclean/'
                            target='_blank'
                            rel='noreferrer'
                            title='instagram'
                        >
                            <RiInstagramFill />
                        </Link >
                    </li>
                </ul>
            </nav>
        </footer>
    )
}

export default Footer